export const firebaseCredentials = {
  apiKey: "AIzaSyDNxJoX6n5puyPUM1ycj7efQAwJ1BpInB0",
  authDomain: "chef-circle.firebaseapp.com",
  databaseURL: "https://chef-circle.firebaseio.com",
  projectId: "chef-circle",
  storageBucket: "chef-circle.appspot.com",
  messagingSenderId: "643701607432",
  appId: "1:643701607432:web:4ca24c4efe21539636d5bd"
};